"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var index_vue_1 = require("./index.vue");
document.querySelectorAll('.v-filter').forEach(function (appElement) {
    var attrs = appElement.getAttributeNames();
    var initProps = {};
    var props = index_vue_1.default.props;
    !Array.isArray(props) ? props = props.map(function (p, i) { return i; }) : true;
    attrs.map(function (attrName) { props.indexOf(attrName) >= 0 ? initProps[attrName] = appElement.getAttribute(attrName) : false; });
    vue_1.createApp(index_vue_1.default, initProps)
        .mount(appElement);
});
